module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0118.jpg?v=ee12f4a1";